export default {
  setAdminProductList(state, productList) {
    state.productList = [...state.productList, ...productList];
  },

  setInitAdminProductList(state, productList) {
    state.page = 1;
    state.totalPage = 2;
    state.productList = productList;
  },

  initList(state) {
    state.page = 1;
    state.totalPage = 2;
    state.productList = [];
    state.storeCategoryList = [];
  },

  setProductDetail(state, data = {}) {
    state.productInfo = data;
  },

  setPage(state, page = 1) {
    state.page = page;
  },

  setTotalPage(state, totalPage = 2) {
    state.totalPage = totalPage;
  },

  setStoreCategoryList(state, list) {
    state.storeCategoryList = list;
  },

  setProductCategoryList(state, list) {
    state.productCategoryList = list;
  }
};
